export const INTEGRATIONS_TEAM_EMAIL = 'integrations@servicetitan.com';
